import {
    createSlice,
    PayloadAction,
    createAsyncThunk
  } from '@reduxjs/toolkit';
  import type { RootState } from 'app/store';
  import { getData, postFormData } from 'utils/service';
  // declaring the types for our state
  export type DemoState = {
    data: any;
    pending: boolean;
  };
  
  const initialState: DemoState = {
    data: [],
    pending: false,
  };

  // This action is what we will call using the dispatch in order to trigger the API call.
  export const getDemoData = createAsyncThunk('api/demo_videos', async () => {
    let data: any = { }
    let response: any = await getData('demo_videos', data);
    if (response.success === "true") {
      return response
    }
    return {};
  });
  
  export const demoSlice = createSlice({
    name: 'demos',
    initialState,
    reducers: {
    },

    extraReducers: builder => {
      builder
        .addCase(getDemoData.pending, state => {
          state.pending = true;
        })
        .addCase(getDemoData.fulfilled, (state, { payload }) => {
          state.pending = false;
          state.data = (payload.data) ? payload.data : [];
        });
    },

  });
  // Here we are just exporting the actions from this slice, so that we can call them anywhere in our app.
  export const {
   
  } = demoSlice.actions;
  
  // calling the above actions would be useless if we could not access the data in the state. So, we use something called a selector which allows us to select a value from the state.
  export const selectDemo = (state: RootState) => state.demos;
  
  // exporting the reducer here, as we need to add this to the store
  export default demoSlice.reducer;